import http from "./httpClient.js";

export async function getTrialInfo(schoolId, styleId = null, packageId = null) {
  const params = new URLSearchParams();
  if (styleId) params.set('styleId', styleId);
  if (packageId) params.set('packageId', packageId);
  const qs = params.toString() ? `?${params.toString()}` : '';
  const response = await http.get(`/school/${schoolId}/trial${qs}`);
  return response.data;
}

export async function claimTrial(schoolId, danceStyleId, referredBy) {
  const body = { danceStyleId };
  if (referredBy) body.referredBy = referredBy;
  const response = await http.post(`/school/${schoolId}/claim-trial`, body);
  return response.data;
}
